/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: 'Solutions'
})
